module.exports = __webpack_public_path__ + "static/media/temperature-scan.9b960494.svg";